import React, { useState } from 'react';
import { IconButton, Select, MenuItem, Tooltip
 } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import {
  Edit as EditIcon,
  Check as CheckIcon,
  Remove as RemoveIcon
} from '@mui/icons-material';

import customLocaleText from '../../constants/DataGridLocaleTextConstants.js';
import moment from 'moment';
import { useAuth } from '../../context/AuthContext.js';

function KeywordsDataGrid({ keywords, handleOpenDeleteModal, handleOpenModal }) {
  const [paginationModel] = useState({ page: 0, pageSize: 10 });
  const { user } = useAuth();

  const getDateFromTimestamp = (timestamp) => {
    if (!timestamp) return 'Fecha inválida';
    return moment.unix(timestamp).format('DD-MM-YYYY HH:mm:ss');
  };

  const customFilterOperators = [
    {
      label: 'Obligatorio/NoObligatorio',
      value: 'isRequiredFilter',
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) return null;
        const isRequired = filterItem.value === 'required';
        return (row) => (row === isRequired);
      },
      InputComponent: ({ item, applyValue }) => (
        <Select
          value={item.value || ''}
          onChange={(event) => applyValue({ ...item, value: event.target.value })}
          style={{ width: '100%', marginTop: 'auto' }}
          data-testid="customStatusSelect"
          id="customStatusSelect"
        >
          <MenuItem value="">
            <em>--Seleccione--</em>
          </MenuItem>
          <MenuItem value={"required"}>Obligatorio</MenuItem>
          <MenuItem value={"no_required"}>No obligatorio</MenuItem>
        </Select>
      ),
    },
  ];

  const columns = [
    { field: 'name', headerName: 'Nombre', flex: 0.3, filterable: true },
    { field: 'description', headerName: 'Descripción', flex: 0.3, filterable: true },
    {
      display: 'flex',
      field: 'is_required',
      headerName: 'Obligatorio',
      flex: 0.1,
      filterable: true,
      filterOperators: customFilterOperators,
      renderCell: (params) => (params.row.is_required ? <CheckIcon sx={{color: 'green'}} /> : <RemoveIcon />)
    },
    {
      field: 'created_at',
      headerName: 'Fecha de creación',
      valueGetter: (params) => getDateFromTimestamp(params?._seconds),
      flex: 0.3,
      filterable: true,
    },
    {
      field: 'updated_at',
      headerName: 'Fecha ultima edición',
      valueGetter: (params) => getDateFromTimestamp(params?._seconds),
      flex: 0.3,
      filterable: true,
    },
  ];

  if(user?.isAdmin){
    columns.push({
      field: 'actions',
      headerName: 'Acciones',
      flex: 0.2,
      renderCell: (params) => (
        <div>
          <Tooltip title="Editar">
            <IconButton
              onClick={() => handleOpenModal(params.row)}
              color="primary"
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
    });
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '600px',
      }}
    >
      <DataGrid
        rows={keywords}
        columns={columns}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[5, 10, 15, 20]}
        checkboxSelection={false}
        rowSelection={false}
        sx={{ border: 0 }}
        localeText={customLocaleText}
      />
    </div>
  );
}

export default KeywordsDataGrid;
